export const prepareSourceUrl = (sourceUrl: string) => {
    if (sourceUrl && !sourceUrl.startsWith('http') && sourceUrl.length > 0) {
        const pathPrefix = sourceUrl[0].toLowerCase()

        if (!sourceUrl.endsWith('.pdf')) {
            sourceUrl = `${sourceUrl}.pdf`
        }

        const baseUrl = import.meta.env.VITE_S3_DOCS_BUCKET_URL || 'https://app-docs.financelab.se/'

        return `${baseUrl}${pathPrefix}/${sourceUrl}`
    } else return sourceUrl
}
